import { FormLabel, SxProps, Typography, TypographyProps } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import MuiRadioGroup from '@mui/material/RadioGroup';
import { ReactElement } from 'react';

const labelStyle: SxProps = {
  fontWeight: 'bold',
  color: 'text.primary',
  '&.Mui-focused': {
    color: 'text.primary'
  },
  fontSize: '14px',
  mb: 2
};

type Option = {
  value: string;
  label: string | ReactElement;
  disabled?: boolean;
};

type Props = {
  label?: string | ReactElement;
  options: Option[];
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  name?: string;
  labelContainer?: SxProps;
  value?: string | null;
  radioTypographyPropsOverride?: TypographyProps;
  radioSx?: SxProps;
  formSx?: SxProps;
  containerSx?: SxProps;
};

/**
 * @deprecated use 'RadioGroup' from 'common/form'
 */
export const RadioGroup: React.FC<Props> = ({
  name = 'radio-buttons-group',
  options,
  value,
  onChange,
  label,
  labelContainer,
  radioTypographyPropsOverride,
  radioSx,
  formSx,
  containerSx
}) => {
  return (
    <FormControl fullWidth>
      <FormLabel sx={{ ...labelStyle, ...labelContainer }}>{label}</FormLabel>
      <MuiRadioGroup
        aria-labelledby="radio-buttons-group-label"
        name={name}
        onChange={onChange}
        value={value}
        sx={containerSx}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            disabled={option.disabled}
            control={<Radio sx={radioSx} />}
            label={
              !radioTypographyPropsOverride ? (
                option.label
              ) : (
                <Typography sx={radioTypographyPropsOverride}>
                  {option.label}
                </Typography>
              )
            }
            sx={{
              '& .MuiFormControlLabel-label': {
                width: '100%'
              },
              ...formSx
            }}
          />
        ))}
      </MuiRadioGroup>
    </FormControl>
  );
};
